import { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { Alert, FormControl } from "react-bootstrap";
import { connect, Dispatch } from "react-redux";
import { ICenterListResponse } from "@nkr/store/center/index";;
import { IApplicationState, MicrositeActionCreators } from "@nkr/store/index";
import { ICenter } from "@nkr/models/center";
import { ICenterAddress } from "@nkr/models/index";
import { Highlighter } from "react-bootstrap-typeahead";

interface IProps {
    value: number,
    enabled: boolean,
    onlyMicrositeCenters?: boolean,
    onChange?: (v: number) => void,
}

interface IStateProps { }

interface IDispatchProps {
    getCenterList: () => Promise<ICenterListResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface ICenterOption extends ICenter {
    label: string,
    address: string,
    city: string,
    shortState: string,
    state: string
}

const CenterTypeahead = ({ value, enabled, onChange, getCenterList, onlyMicrositeCenters }: TProps) => {
    const [centers, setCenters] = useState<ICenter[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsLoading(true);

        getCenterList()
            .then(r => {
                setCenters(r.data.results.filter((c) => !c.isDeleted && (!onlyMicrositeCenters || c.isMicrositeParticipant == true)));
                // setCenters(r.data.results);
            })
            .catch((ex) => {
                setError(ex);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const centerList: ICenterOption[] = centers?.map(c => {
        const mainAddress: ICenterAddress = c.centerAddresses.find(a => a.typeId == 1);
        const al = mainAddress ? `, Address: ${mainAddress?.addressLine1} ${mainAddress?.city}, ${mainAddress?.stateAbbreviation}` : '';
        const label = `Alias: ${c.alias}${al}`;

        return {
            ...c,
            label,
            address: mainAddress?.addressLine1,
            city: mainAddress?.city,
            shortState: mainAddress?.stateAbbreviation,
            state: mainAddress?.state
        };
    });

    const selected = centerList.filter(o => o.id == value)

    const handleChange = (v: ICenterOption) => {
        onChange(v[0]?.id)
    }

    if (error) {
        return <Alert bsStyle='danger'>An error occurred while retrieving centers. If this error persists please contact support.</Alert>;
    }

    if (isLoading) {
        return <Alert bsStyle='info'>Loading Centers ...</Alert>
    }

    return (<>
        <Typeahead
            id='nkr-center'
            clearButton={true}
            labelKey={option => `${option.alias} ${option.name?.trim()} ${option.address?.trim()}, ${option.city}, ${option.shortState}`}
            options={centerList}
            selected={selected}
            disabled={!enabled}
            filterBy={['alias', 'name', 'city', 'shortState', 'address', 'state']}
            renderInput={(inputProps) => (
                <FormControl {...inputProps} />
            )}
            renderMenuItemChildren={(option, props) => {
                return (
                    <div style={{ borderBottom: '1px solid #ddd', paddingBottom: 5 }}>
                        <div>Alias: <Highlighter search={props.text}>{option.alias}</Highlighter></div>
                        <div><small>Name: <Highlighter search={props.text}>{option.name}</Highlighter></small></div>
                        {option.address && <div>
                            <small>Address: <Highlighter search={props.text}>{`${option.address?.trim()}, ${option.city}, ${option.shortState}`}</Highlighter></small>
                        </div>}
                    </div>
                );
            }}
            onChange={handleChange}
        />
    </>);
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        getCenterList: () => {
            return dispatch(MicrositeActionCreators.getCenterList());
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterTypeahead);